import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./YouTubeChannelButton.module.scss";

type Props = {
  link: string;
};
const YouTubeChannelButton: React.FC<Props> = ({ link }) => {
  if (link) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={styles["youtube-channel-button"]}
      >
        <FontAwesomeIcon icon={["fab", "youtube"]} />
        <span>
          Youtube チャンネル
          <FontAwesomeIcon icon={["fas", "external-link-alt"]} />
        </span>
      </a>
    );
  } else {
    return null;
  }
};

export default YouTubeChannelButton;
